import { render, staticRenderFns } from "./global-process-dialog.vue?vue&type=template&id=128f6a52&scoped=true&"
import script from "./global-process-dialog.vue?vue&type=script&lang=js&"
export * from "./global-process-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f6a52",
  null
  
)

export default component.exports